import { _axios } from "../../../Utils/Axios/axios";

export const getPartsOfTeachItemWithIdService = async (
  userToken: string,
  teachItemId: string
) => {
  return _axios.post(
    `/user_part/${teachItemId}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    }
  );
};
